/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsUnderlined: {
  name: 'underlined';
  data: string;
} = {
  name: 'underlined',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 1a.5.5 0 0 0-1 0v6a4.5 4.5 0 0 0 9 0V1a.5.5 0 0 0-1 0v6a3.5 3.5 0 1 1-7 0V1ZM2 14.5a.5.5 0 0 0 0 1h12a.5.5 0 0 0 0-1H2Z" fill="currentColor"/></svg>`,
};
